// Hamburger Menu Toggle Functionality
document.addEventListener("DOMContentLoaded", function () {
  const hamburgerMenu = document.querySelector(".hamburger-menu")
  const mobileNavigation = document.querySelector(".mobile-navigation")
  const mobileOverlay = document.querySelector(".mobile-menu-overlay")

  if (hamburgerMenu && mobileNavigation) {
    hamburgerMenu.addEventListener("click", function () {
      // Toggle active class on hamburger
      hamburgerMenu.classList.toggle("active")

      // Toggle active class on mobile navigation
      mobileNavigation.classList.toggle("active")

      // Toggle overlay
      if (mobileOverlay) {
        mobileOverlay.classList.toggle("active")
      }

      // Update aria-expanded attribute
      const isExpanded = hamburgerMenu.classList.contains("active")
      hamburgerMenu.setAttribute("aria-expanded", isExpanded.toString())
    })

    // Close menu when clicking on a menu item (except when toggling parent with submenu)
    const menuItems = mobileNavigation.querySelectorAll(".primary-menu a")
    menuItems.forEach(item => {
      item.addEventListener("click", function () {
        const li = item.closest("li")
        if (li && li.classList.contains("menu-item-has-children")) {
          return // Don't close when parent link is used to open submenu
        }
        closeMobileMenu()
      })
    })

    // Close menu when clicking on overlay
    if (mobileOverlay) {
      mobileOverlay.addEventListener("click", function () {
        closeMobileMenu()
      })
    }

    // Close menu when clicking outside
    document.addEventListener("click", function (event) {
      if (!hamburgerMenu.contains(event.target) && !mobileNavigation.contains(event.target) && (!mobileOverlay || !mobileOverlay.contains(event.target))) {
        closeMobileMenu()
      }
    })

    // Close menu on escape key
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && mobileNavigation.classList.contains("active")) {
        closeMobileMenu()
      }
    })
  }

  function closeMobileMenu() {
    hamburgerMenu.classList.remove("active")
    mobileNavigation.classList.remove("active")
    if (mobileOverlay) {
      mobileOverlay.classList.remove("active")
    }
    hamburgerMenu.setAttribute("aria-expanded", "false")
  }

  // Mobile submenu behavior: insert real indicator elements and use them as click receivers
  ;(function setupMobileSubmenus() {
    const mobileNav = document.querySelector(".mobile-navigation")
    if (!mobileNav) return

    const items = mobileNav.querySelectorAll(".menu-item-has-children")
    items.forEach(li => {
      const link = li.querySelector(":scope > a")
      const submenu = li.querySelector(":scope > .sub-menu")
      if (!link || !submenu) return

      // ensure li is positioned for indicator absolute placement
      li.style.position = li.style.position || ""

      // create indicator element if missing
      if (!li.querySelector(":scope > .submenu-indicator")) {
        const indicator = document.createElement("button")
        indicator.type = "button"
        indicator.className = "submenu-indicator"
        indicator.setAttribute("aria-expanded", "false")
        indicator.setAttribute("aria-label", "Toggle submenu")
        indicator.innerHTML = '<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>'
        // place after the link
        link.append(indicator)

        // click toggles submenu (mobile only)
        indicator.addEventListener("click", function (e) {
          if (!window.matchMedia("(max-width: 900px)").matches) return
          e.preventDefault()
          e.stopPropagation()
          const isOpen = li.classList.contains("submenu-open")
          if (isOpen) {
            const start = submenu.scrollHeight
            submenu.style.height = start + "px"
            requestAnimationFrame(() => {
              submenu.style.transition = "height 300ms ease"
              submenu.style.height = "0px"
            })
            li.classList.remove("submenu-open")
            indicator.setAttribute("aria-expanded", "false")
            const cleanup = function () {
              submenu.style.transition = ""
              submenu.style.height = ""
              submenu.removeEventListener("transitionend", cleanup)
            }
            submenu.addEventListener("transitionend", cleanup)
          } else {
            li.classList.add("submenu-open")
            submenu.style.height = "0px"
            requestAnimationFrame(() => {
              const full = submenu.scrollHeight
              submenu.style.transition = "height 300ms ease"
              submenu.style.height = full + "px"
            })
            indicator.setAttribute("aria-expanded", "true")
            const cleanupOpen = function () {
              submenu.style.transition = ""
              submenu.style.height = "auto"
              submenu.removeEventListener("transitionend", cleanupOpen)
            }
            submenu.addEventListener("transitionend", cleanupOpen)
          }
        })

        // keyboard accessibility
        indicator.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            indicator.click()
          }
        })
      }
    })
  })()

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".share-button")
    if (!btn) return

    const url = btn.dataset.shareUrl
    if (!url) return

    const width = 600
    const height = 600

    const left = (window.screen.width - width) / 2
    const top = (window.screen.height - height) / 2

    window.open(url, "share-popup", `width=${width},height=${height},top=${top},left=${left},noopener,noreferrer`)
  })

  // Share modal (moved from inline PHP script)
  document.addEventListener("click", function (e) {
    const trigger = (e.target.closest && e.target.closest(".pingvin-share-trigger")) || (e.target.classList && e.target.classList.contains("pingvin-share-trigger") && e.target)
    if (!trigger) return
    e.preventDefault()
    console.log("pingvin-share: trigger clicked")
    let wrapper = trigger.closest(".social-share-icons")
    if (!wrapper) wrapper = trigger.parentElement
    if (!wrapper) {
      console.warn("pingvin-share: no wrapper found")
      return
    }
    const popup = wrapper.querySelector && wrapper.querySelector(".pingvin-share-popup")
    if (!popup) {
      console.warn("pingvin-share: no popup content found")
      return
    }
    const html = popup.innerHTML && popup.innerHTML.trim()
    if (!html) {
      console.warn("pingvin-share: popup content empty")
      return
    }

    const overlay = document.createElement("div")
    overlay.className = "pingvin-share-overlay"
    Object.assign(overlay.style, {
      position: "fixed",
      left: "0",
      top: "0",
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: "99999"
    })

    const box = document.createElement("div")
    box.className = "pingvin-share-box"
    Object.assign(box.style, {
      background: "#ffffff",
      color: "#fe0000",
      padding: "18px",
      borderRadius: "6px",
      maxWidth: "90%",
      boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
    })
    box.innerHTML = html
    overlay.appendChild(box)

    overlay.addEventListener("click", function (ev) {
      if (ev.target === overlay) {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay)
        document.removeEventListener("keydown", onKey)
      }
    })

    function onKey(ev) {
      if (ev.key === "Escape") {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay)
        document.removeEventListener("keydown", onKey)
      }
    }
    document.addEventListener("keydown", onKey)

    if (document.body) document.body.appendChild(overlay)
    else console.warn("pingvin-share: document.body not available")
  })

  // Popup search overlay (triggered by #search-toggle)
  const searchToggle = document.getElementById("search-toggle")
  if (searchToggle) {
    searchToggle.addEventListener("click", function (e) {
      e.preventDefault()

      const overlay = document.createElement("div")
      overlay.className = "search-overlay"
      Object.assign(overlay.style, {
        position: "fixed",
        inset: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "100000"
      })

      const box = document.createElement("div")
      box.className = "search-box"
      Object.assign(box.style, {
        width: "min(720px, 92%)",
        padding: "18px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
      })

      const form = document.createElement("form")
      form.setAttribute("role", "search")
      form.setAttribute("method", "get")
      form.setAttribute("action", "/")
      form.className = "search-popup-form"

      const input = document.createElement("input")
      input.setAttribute("type", "search")
      input.setAttribute("name", "s")
      input.setAttribute("placeholder", "Search…")
      input.className = "search-popup-input"
      Object.assign(input.style, { width: "100%", fontSize: "1.15rem", padding: "12px 14px" })

      const actions = document.createElement("div")
      Object.assign(actions.style, { display: "flex", gap: "8px" })

      const submit = document.createElement("button")
      submit.setAttribute("type", "submit")
      submit.className = "search-popup-submit"
      submit.textContent = "Search"
      Object.assign(submit.style, { padding: "14px 14px", border: "none", cursor: "pointer" })

      actions.appendChild(submit)
      form.appendChild(input)
      form.appendChild(actions)
      box.appendChild(form)
      overlay.appendChild(box)

      function removeOverlay() {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay)
        document.removeEventListener("keydown", onKey)
      }
      overlay.addEventListener("click", function (ev) {
        if (ev.target === overlay) removeOverlay()
      })
      function onKey(ev) {
        if (ev.key === "Escape") removeOverlay()
      }
      document.addEventListener("keydown", onKey)

      document.body.appendChild(overlay)
      setTimeout(function () {
        input.focus()
      }, 50)
    })
  }
  // Smooth scrolling for anchor links with fixed header offset
  ;(function smoothAnchors() {
    const header = document.querySelector(".site-header, header")
    function getHeaderHeight() {
      if (!header) return 0
      return header.getBoundingClientRect().height
    }

    // intercept clicks on same-page anchors
    document.addEventListener("click", function (e) {
      const a = e.target.closest('a[href^="#"]')
      if (!a) return
      const href = a.getAttribute("href")
      if (!href || href === "#") return
      const id = href.slice(1)
      const target = document.getElementById(id)
      if (!target) return
      e.preventDefault()
      const top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderHeight()
      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: "smooth" })
      try {
        history.pushState && history.pushState(null, "", href)
      } catch (err) {
        location.hash = href
      }
    })

    // on load with hash, adjust scroll position to account for header
    if (window.location.hash) {
      const id = window.location.hash.slice(1)
      const el = document.getElementById(id)
      if (el) {
        setTimeout(() => {
          const top = el.getBoundingClientRect().top + window.pageYOffset - getHeaderHeight()
          window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: "smooth" })
        }, 50)
      }
    }
  })()
})

// Initialize gallery slider behavior
import "./gallery-slider"
